import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

import { api } from '@/api/client';
import type { SessionUser } from '@/api/types';

export const useAuthStore = defineStore('auth', () => {
  const user = ref<SessionUser | null>(null);
  const resolved = ref(false);

  const isAuthenticated = computed(() => user.value !== null);
  const isAdmin = computed(() => user.value?.role === 'admin');

  /** Called once by the router guard before the first navigation resolves. */
  async function restore(): Promise<void> {
    if (resolved.value) return;
    try {
      user.value = await api.me();
    } catch {
      user.value = null;
    } finally {
      resolved.value = true;
    }
  }

  async function login(email: string, password: string): Promise<void> {
    user.value = await api.login(email, password);
    resolved.value = true;
  }

  async function logout(): Promise<void> {
    await api.logout();
    user.value = null;
  }

  return { user, resolved, isAuthenticated, isAdmin, restore, login, logout };
});
